export { default } from './CarPricePdf';
